import { contactCard } from './contactCard';

export const propertyManagingAgentCard = contactCard(
  'additionalContacts.propertyManagingAgent',
  'propertyManagingAgent',
);
